import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context'

const httpLink = new HttpLink({ uri: process.env.VUE_APP_API_ENDPOINT })

const httpLinkAuth = setContext((_, { headers }) => {
    // get the authentication token from localstorage if it exists
    const token = localStorage.getItem('USER_TOKEN')

    // return the headers to the context so httpLink can read them
    return {
        headers: {
            ...headers,
            Authorization: token ? `Bearer ${token}` : ''
        }
    }
})

// create the apollo client
const graphqlClient = new ApolloClient({
    link: httpLinkAuth.concat(httpLink),
    cache: new InMemoryCache()
})

export { graphqlClient }